<template>
  <!-- 信用限额table -->
  <a-table
    :columns="creditLimitColumns"
    :data-source="dataSource"
    :pagination="false"
    bordered
    :scroll="SCROLL"
  >
    <!-- 自定义渲染表头的title行 -->
    <label
      v-for="titleItem in customTitleList"
      :key="titleItem.keyName"
      :for="`${TABLE_NAME}_${titleItem.keyName}`"
      :slot="`${titleItem.keyName}Title`"
      class="ant-form-item-required"
    >
      {{ titleItem.title }}
    </label>

    <span slot="type" v-if="type == 1">信用限额</span>
    <span slot="type" v-else-if="type == 4">专项额度</span>
    <span slot="amount" slot-scope="text">{{ text | formatAmount }}</span>
    <!-- <span slot="totalWithRoadAmount" slot-scope="text, record">
      {{
        loadTotalWithRoadAmount(record.amount, record.limitAmountFinal)
          | formatAmount
      }}
      {{ record.limitAmountFinal | formatAmount }}
    </span> -->
    <span slot="oldIndateEnd" slot-scope="text">{{ text }}</span>
    <span slot="newIndateEnd" slot-scope="text">至 {{ text }}</span>

    <template slot="limitConditionType" slot-scope="text, record">
      <span v-if="!record.limitConditionType">
        无
      </span>
      <span v-else>
        NET AR 超 {{ record.limitConditionAmount | formatAmount }} 元控货
      </span>
    </template>
        <!-- 货币 -->
    <template slot="moneyId" slot-scope="text, record">
      <span v-if="record.moneyId == 0">
        人民币
      </span>
      <span v-else>
        {{ record.moneyName }}
      </span>
    </template>
  </a-table>
</template>

<script>
import { CREDIT_TYPE_OBJ, CREDIT_TYPE_VALUE_OBJ } from '../const'
import {
  TYPE_WIDTH,
  INDATE_WIDTH,
  TERM_WIDTH,
  INDATE_START_WIDTH,
  LIMIT_CONDITION_WIDTH,
  SCROLL,
  AMOUNT_WIDTH,
} from '../components/ApplyDetail/config'

const TABLE_NAME = 'limitExtensionTable'
export default {
  name: 'LimitExtensionTable',
  data() {
    return {
      TABLE_NAME,
      CREDIT_TYPE_VALUE_OBJ,
      SCROLL,
      creditLimitColumns: [
        {
          title: '信用类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          width: TYPE_WIDTH,
        },
        {
          dataIndex: 'amount',
          slots: { title: 'amountTitle' },
          scopedSlots: { customRender: 'amount' },
          width: AMOUNT_WIDTH,
        },
        // {
        //   title: '申请后限额峰值',
        //   dataIndex: 'totalWithRoadAmount',
        //   scopedSlots: { customRender: 'totalWithRoadAmount' },
        //   width: TOTAL_AMOUNT_WIDTH,
        // },
        {
          dataIndex: 'moneyId',
          slots: { title: 'moneyIdTitle' },
          scopedSlots: { customRender: 'moneyId' },
          width: TERM_WIDTH,
        },
        {
          dataIndex: 'indateStart',
          slots: { title: 'indateStartTitle' },
          scopedSlots: { customRender: 'indateStart' },
          width: INDATE_START_WIDTH,
        },
        {
          dataIndex: 'oldIndateEnd',
          slots: { title: 'oldIndateEndTitle' },
          scopedSlots: { customRender: 'oldIndateEnd' },
          width: INDATE_START_WIDTH,
        },
        {
          dataIndex: 'newIndateEnd',
          slots: { title: 'newIndateEndTitle' },
          scopedSlots: { customRender: 'newIndateEnd' },
          width: INDATE_WIDTH,
        },
        {
          title: '账期(天)',
          dataIndex: 'term',
          width: TERM_WIDTH,
        },
        {
          title: '限额条件',
          dataIndex: 'limitConditionType',
          scopedSlots: { customRender: 'limitConditionType' },
          width: LIMIT_CONDITION_WIDTH,
        },
      ],
      // 自定义表头中title
      customTitleList: [
        {
          title: '额度(元)',
          keyName: 'amount',
        },
        {
          title: '货币',
          keyName: 'moneyId',
        },
        {
          title: '额度生效日',
          keyName: 'indateStart',
        },
        {
          title: '原始额度有效期',
          keyName: 'oldIndateEnd',
        },
        {
          title: '申请延期至',
          keyName: 'newIndateEnd',
        },
        {
          title: '限额条件',
          keyName: 'limitConditionType',
        },
      ],
    }
  },
  props: ['type', 'dataSource', 'baseInfo'],
  computed: {
    typeText() {
      return CREDIT_TYPE_OBJ[CREDIT_TYPE_VALUE_OBJ.CREDIT_TYPE]
    },
  },

  methods: {
    loadTotalWithRoadAmount(num, limitAmountFinal) {
      const baseInfo = this.baseInfo
      if (baseInfo) {
        console.log(baseInfo)
        const running = baseInfo.running
        if (running == 1) {
          const totalCreditLimitWithRoad =
            this.baseInfo.totalCreditLimitWithRoad || 0
          const amount = num || 0
          return parseFloat(amount) + parseFloat(totalCreditLimitWithRoad)
        }
        return limitAmountFinal
      }
      return 0
    },
  },
}
</script>

<style></style>
